import React from 'react'
import Videopage from '../components/Videopage/Videopage'

function Video() {
  return (
    <div>
        <Videopage/>
      
    </div>
  )
}

export default Video
